import { useQuery } from '@tanstack/react-query';
import { searchAnalyticsApi } from '../api/searchAnalyticsApi';
import type { SearchAnalyticsQuery, TopSearchesQuery } from '../types';

/**
 * Every hook below takes `enabled` explicitly — the page must pass
 * `!!selectedTenantId` (or similar) so no request fires before a merchant is
 * selected; the backend 400s otherwise and there's nothing tenant-agnostic to show.
 */

export const useTopSearches = (query: TopSearchesQuery, enabled: boolean) =>
  useQuery({
    queryKey: ['search-analytics', 'top-searches', query],
    queryFn: () => searchAnalyticsApi.getTopSearches(query),
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

export const useNoResultSearches = (query: TopSearchesQuery, enabled: boolean) =>
  useQuery({
    queryKey: ['search-analytics', 'no-result-searches', query],
    queryFn: () => searchAnalyticsApi.getNoResultSearches(query),
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

export const useSearchStats = (query: SearchAnalyticsQuery, enabled: boolean) =>
  useQuery({
    queryKey: ['search-analytics', 'stats', query],
    queryFn: () => searchAnalyticsApi.getStats(query),
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
